/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './subscribeModEvents.defs'
export { main as default } from './subscribeModEvents.defs'
